import { useEffect, useState } from 'react'

export const useFileObjectUrl = (file?: File | string) => {
  const [url, setUrl] = useState<string | undefined>(typeof file === 'string' ? file : undefined)
  useEffect(() => {
    let url: string
    if (file instanceof File) {
      url = URL.createObjectURL(file)
      setUrl(url)
    } else if (typeof file === 'string') {
      setUrl(file)
      return
    } else {
      setUrl(undefined)
      return
    }

    return () => {
      if (url) {
        URL.revokeObjectURL(url)
      }
    }
  }, [file])
  return { url }
}
